export const TableCellWidgetId = 'TableCellWidget';

export enum TableCellWidgetAttributes {
  CONTENT = 'content',
  WIDTH = 'width',
}
